import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface NotificationState {
  count: any;
  countByType: any;
  notificationsByStatus: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "count" | "count-by-type" | "by-status" | null;
}

const notificationsInitialState: NotificationState = {
  count: null,
  countByType: null,
  notificationsByStatus: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getNotificationsCount: any = createAsyncThunk(
  "get/notifications/count",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.NOTIFICATIONS.NOTIFICATIONS_COUNT,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getNotificationsCountByType: any = createAsyncThunk(
  "get/notifications/count-by-type",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.NOTIFICATIONS.NOTIFICATIONS_COUNT_BY_TYPE,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getNotificationsByStatus: any = createAsyncThunk(
  "get/notifications/by-status",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.NOTIFICATIONS.NOTIFICATIONS_BY_STATUS,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const notificationSlice = createSlice({
  name: "reset",
  initialState: notificationsInitialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.count = null;
      state.action = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNotificationsCount.pending, (state) => {
      state.loading = "pending";
      state.count = null;
      state.error = null;
      state.action = "count";
    });
    builder.addCase(getNotificationsCount.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.count = action.payload;
      state.error = null;
      state.action = "count";
    });
    builder.addCase(getNotificationsCount.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.count = null;
      state.action = "count";
    });

    builder.addCase(getNotificationsCountByType.pending, (state) => {
      state.loading = "pending";
      state.countByType = null;
      state.error = null;
      state.action = "count-by-type";
    });
    builder.addCase(getNotificationsCountByType.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.countByType = action.payload;
      state.error = null;
      state.action = "count-by-type";
    });
    builder.addCase(getNotificationsCountByType.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.countByType = null;
      state.action = "count-by-type";
    });

    builder.addCase(getNotificationsByStatus.pending, (state) => {
      state.loading = "pending";
      state.notificationsByStatus = null;
      state.error = null;
      state.action = "by-status";
    });
    builder.addCase(getNotificationsByStatus.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.notificationsByStatus = action.payload;
      state.error = null;
      state.action = "by-status";
    });
    builder.addCase(getNotificationsByStatus.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.notificationsByStatus = null;
      state.action = "by-status";
    });
  },
});

export const { resetAll } = notificationSlice.actions;
export default notificationSlice.reducer;
